module.exports = __webpack_public_path__ + "img/ThomasSchwarz_140x140_rund.fd27fe28.jpg";